export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg
    className={className}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect x="1" y="1" width="30" height="30" rx="9" fill="#1B365D" />
    <rect x="6" y="5" width="20" height="22" rx="3" fill="#FBF7EF" />
    <rect x="8.5" y="7.5" width="10" height="12.5" rx="1.5" fill="#1B365D" />
    <rect x="8.5" y="12.3" width="10" height="0.8" fill="#FBF7EF" />
    <rect x="8.5" y="16.8" width="10" height="0.8" fill="#FBF7EF" />
    <rect x="9.6" y="9.4" width="2" height="2.4" rx="0.4" fill="#C9A227" />
    <rect x="12.5" y="9.4" width="2" height="2.4" rx="0.4" fill="#C9A227" />
    <rect x="15.4" y="9.4" width="2" height="2.4" rx="0.4" fill="#C9A227" />
    <rect x="9.6" y="13.9" width="2" height="2.4" rx="0.4" fill="#C9A227" />
    <rect x="12.5" y="13.9" width="2" height="2.4" rx="0.4" fill="#C9A227" />
    <rect x="15.4" y="13.9" width="2" height="2.4" rx="0.4" fill="#C9A227" />
    <rect x="8.5" y="22.3" width="10" height="3" rx="1" fill="#C9A227" />
    <rect x="20.5" y="7.5" width="4" height="1" rx="0.5" fill="#C9A227" />
    <circle cx="21.7" cy="11.4" r="0.8" fill="#C9A227" />
    <circle cx="24" cy="11.4" r="0.8" fill="#C9A227" />
    <circle cx="21.7" cy="13.8" r="0.8" fill="#C9A227" />
    <circle cx="24" cy="13.8" r="0.8" fill="#C9A227" />
    <rect x="20.5" y="16.5" width="4.5" height="3.4" rx="0.8" fill="#1B365D" />
  </svg>
);

export default function Logo({ onClick }) {
  return (
    <a
      href="#top"
      data-testid="nav-logo-link"
      onClick={(e) => {
        e.preventDefault();
        if (onClick) onClick();
        const el = document.getElementById("top");
        if (el) {
          if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.2 });
          else window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }}
      className="flex items-center gap-2.5"
      aria-label="SnackSavvy Vending Services home"
    >
      <LogoMark />
      <span className="leading-none">
        <span className="block font-display text-lg font-extrabold tracking-tight text-[#16120E]">
          SnackSavvy
        </span>
        <span className="mt-0.5 block font-mono text-[9px] uppercase tracking-[0.32em] text-[#A8861D]">
          Vending Services
        </span>
      </span>
    </a>
  );
}
